import React, { useEffect } from 'react';
import Modal from '@lwt-helix/modal';
import SearchOptionsRow from './common/SearchOptionsRow';
import { setStateData } from '../../common/helpers/state';
import { exportCsv } from './common/exportCsv';
import AddAgentListPopover from './common/AddAgentListPopover';
import { useSavedAgentsTable } from '../hooks/savedAgentsTable';
import { useSavedAgents } from '../hooks/savedAgents';
import { SavedAgentsContent } from './savedAgents/components/SavedAgentsContent';
import { modules, searchRoutes, agentProductionTerms as terms } from '../../constants';
import { useCommonStore, useSavedAgentsStore, useSearchStore } from '../../store/store';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { views } from '../constants/savedAgents';
import Footer from './common/Footer';
import StickyFooter from '@lwt-helix/sticky-footer';
import { getCriteriaObject } from '../../common/helpers/utilities';
import { getFooterLabels } from './savedAgents/helpers';

const SavedAgents = ({ setModuleAgentData }) => {
    const location = useLocation();
    const isActivityRoute = location.pathname === searchRoutes.savedAgentsActivity;
    const clearAgentListPopover = useCommonStore((state) => state.clearAgentListPopover);
    const { state, setState, gridRef } = useSavedAgents({ setModuleAgentData, isActivityRoute });
    const { selectedViewHideAgentsFilter, setViewHideAgentsFilter } = useSearchStore((state) => ({
        selectedViewHideAgentsFilter: state[state.selectedModule]?.selectedViewHideAgentsFilter,
        setViewHideAgentsFilter: state.setViewHideAgentsFilter
    }));
    const selectedMlsDescription = useSearchStore(
        (state) => state[state.selectedModule]?.selectedMls?.shortDescription
    );
    const loadedSearchFields = useSearchStore((state) =>
        getCriteriaObject({
            criteria: state[state.selectedModule]?.loadedSearchCriteria
        })
    );
    const propertyTypes = useCommonStore((state) => state.propertyTypes);
    const isLoading = useSavedAgentsStore((state) => state.isLoading);
    const selectedTimePeriod = useSearchStore((storeState) =>
        state.timeIntervals?.find(
            (ti) =>
                ti.intervalType ===
                storeState[storeState.selectedModule]?.loadedSearchCriteria?.timePeriod
                    ?.intervalType
        )
    );

    const { areaLabel, timePeriodTitle, propertyTypeFooterLabel } = getFooterLabels({
        loadedSearchFields,
        selectedTimePeriod,
        propertyTypes
    });
    const tableSettingsByView = useSavedAgentsTable(state, setState);

    const isGrowthAnalysisLast12MonthsPeriod = state.growthAnalysisPeriod === terms.last12Months;

    const handleShowHideChange = (view) =>
        setViewHideAgentsFilter(modules.proficiencyMetrics.savedAgents, view);

    const setGrowthAnalysisPeriod = (period) => {
        setStateData('growthAnalysisPeriod', period, setState);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => clearAgentListPopover(), []);
    const rowDataToExport = state.selectedView?.value === views.activity
        ? state.activityRowData : state.rowData;
    const columnProps = [
        {
            children: (
                <Footer
                    area={areaLabel || ''}
                    mlsName={selectedMlsDescription || ''}
                    timePeriodTitle={timePeriodTitle || ''}
                    detailedPropertyType={propertyTypeFooterLabel}
                    hasEllipsis={true}
                />
            ),
            sm: 12,
            align: 'left'
        }
    ];

    return (
        <>
            <Modal {...state.modalProps} show={state.showModal} />
            <SearchOptionsRow
                currentColumns={tableSettingsByView[state.selectedView.value]?.columns}
                currentSearchDates={state.currentSearchDates}
                isPeriodLast12Months={isGrowthAnalysisLast12MonthsPeriod}
                growthAnalysisPeriod={state.growthAnalysisPeriod}
                handleShowHideChange={handleShowHideChange}
                selectedAgentsView={selectedViewHideAgentsFilter}
                className={tableSettingsByView[state.selectedView.value].className}
                setColumns={tableSettingsByView[state.selectedView.value]?.setColumns}
                exportCsv={() => exportCsv(state, setState, state.selectedView.value, rowDataToExport)}
                setGrowthAnalysisPeriod={setGrowthAnalysisPeriod}
            />
            <SavedAgentsContent
                gridRef={gridRef}
                tableSettingsByView={tableSettingsByView}
                savedAgentState={state}
                setState={setState}
            />
            <AddAgentListPopover />
            <div id='saved-agents-footer-wrapper'>
                {!isLoading && <StickyFooter columnProps={columnProps} />}
            </div>
        </>
    );
};

export default SavedAgents;

SavedAgents.propTypes = {
    setModuleAgentData: PropTypes.func
};
